import React from "react";

import styles from "./ShowroomGlyph.module.scss";

export const showroomMarkerIcon = `data:image/svg+xml,${encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">' +
        '<circle cx="14.5" cy="14.5" r="14.5" fill="#0c0c0c"/>' +
        '<circle cx="14.5" cy="14.5" r="11" fill="none" stroke="white" stroke-width="1.5"/>' +
        '<text x="14.5" y="15.5" text-anchor="middle" dominant-baseline="central" fill="white" font-family="sans-serif" font-weight="500" font-size="9">SKS</text>' +
        "</svg>",
)}`;

export const ShowroomGlyph = () => {
    return (
        <span className={styles.root} aria-hidden="true">
            <span className={styles.ring} />
            <span className={styles.text}>SKS</span>
        </span>
    );
};
